module.exports = __webpack_public_path__ + "img/sponsor8.7e42a8e6.png";